module.exports = __webpack_public_path__ + "static/media/previous-space.6e475633.png";